import {
	Component,
	OnInit,
	Input,
	Output,
	ViewChild,
	ElementRef,
	EventEmitter,
	OnDestroy
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterService, ToasterConfig, Toast, BodyOutputType } from 'angular2-toaster';
import { Subject, BehaviorSubject, Subscription } from 'rxjs';
import { Observable } from 'rxjs';

import { ProductLine } from '../model/product-line';
import { Facility } from '../model/facility';
import { ProductLineFavorites } from '../model/product-line.favorites';
import { Quote } from '../model/quote';
import { Constants } from "../model/constants";
import { Model } from "../model/model";

import { FacilityService } from '../services/facility.service';
import { UserFavoritesService } from '../services/user-favorites.service';
import { ApplicationStateService } from '../services/application-state.service';
import { LoadingSpinnerService } from "../services/loading-spinner.service";
import { PageTitleService } from "../services/page-title.service";
import { FilterProductlinesService } from "../services/filter-productlines.service";
import { QuoteInfoService } from "../services/quote-info.service";
import { CurrentUserService } from "../services/current-user.service";
import { QuoteSummaryService } from "../services/quote-summary.service";
import { QuoteService } from "../services/quote.service";
import { ModalDialogService } from '../reusable-components/modal-dialog/modal-dialog.service';
import { BrowserWidthService } from "../services/browser-width.service";
import { HttpResponseService } from '../services/httpresponse-service';
import { InformationAsideModelsService } from '../services/information-aside-models.service';

import { OrderByPipe } from '../pipes/orderby.pipe';
import { ToastrProductLinesComponent } from '../reusable-components/toastr-productLines';

@Component({
    selector: 'my-productline-list',
    template: require('./productlines.component.html'),
    styles: [require('./productlines.component.scss')]
})
export class ProductLinesComponent implements OnInit, OnDestroy {
    public _facilityCache: Facility[];
    public _facilityMasterList: Facility[];

    @Input() searchTerm: string;
    searchPipeValue: string;
    searchValue: string;
    displayMode: string;
    Title: string = 'Choose Product Line';
    SubTitle: string = '';
    retailerNumber: string;
    stateError: string;
    currentRetailerNumber: string;
    modifiedBy: string;
    currentUserId: number;

    quote: Quote;
    selectAll: boolean;
    showOnlyFavorites: boolean;
    displayFilter: boolean = false;
    viewFavorites: boolean = false;
    stateIsInvalid: boolean = false;
    processing: Subject<boolean> = new BehaviorSubject(false);
    showingDeactivateModal: boolean = false;

    quoteId: number;

    config: ToasterConfig = new ToasterConfig({
        positionClass: this.browserWidthService.getDisplayMode().width.innerWidth < 769 ? 'toast-bottom-full-width' : 'toast-bottom-right',
        tapToDismiss: false
    });
    toast: Toast;
    favoriteUpdated: BehaviorSubject<number> = new BehaviorSubject(null);

    @Output() searchTermChange: EventEmitter<string> = new EventEmitter<string>();
    //searchUp: Observable<any>;
    facilityFilterButton: string = 'All Facilities';
    search: Observable<any>;
    @ViewChild('search') input: ElementRef;

    subscription: Subscription = new Subscription();

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public facilityService: FacilityService,
        public userFavoritesService: UserFavoritesService,
        public applicationStateService: ApplicationStateService,
        public toasterService: ToasterService,
        public activeRoute: ActivatedRoute,
        public orderBy: OrderByPipe,
        public spinner: LoadingSpinnerService,
        public pageTitleService: PageTitleService,
        public filterProductLinesService: FilterProductlinesService,
        public quoteInfoService: QuoteInfoService,
        public currentUserService: CurrentUserService,
        public quoteSummaryService: QuoteSummaryService,
        public modalDialogService: ModalDialogService,
        public quoteService: QuoteService,
        public browserWidthService: BrowserWidthService,
        public httpResponseService: HttpResponseService,
        public informationAsideModelsService: InformationAsideModelsService
    ) {

        const routeParamsSub = this.route.params.subscribe(x => {
            this.quoteId = x['quoteId'];
            this.quoteInfoService.quoteId$.next(this.quoteId);
        });
        this.subscription.add(routeParamsSub);

        const currentUserSub = this.currentUserService.currentUser$.subscribe(x => {
            this.currentUserId = x.CmhUserId || x.cmhUserId;
            this.currentRetailerNumber = x.retailerNumber;
            this.modifiedBy = x.cmhUserId + '-' + x.firstName + ' ' + x.lastName;
            this.applicationStateService.setCmhUser(x);
        });
        this.subscription.add(currentUserSub);
    }

    ngOnInit() {
        this.spinner.showSpinner();
        this._facilityCache = new Array<Facility>();
        this.searchValue = '';
        this.searchPipeValue = '';

        this.selectAll = true;
        this.processing.next(true);

        if (this.quoteId) {
            this.pageTitleService.pageName.next('Product Lines');
            this.applicationStateService.refreshStateFromDB(this.quoteId, true)
                .subscribe(
                    (dbQuote => {
                        if (dbQuote !== undefined && dbQuote !== null) {
                            this.quote = dbQuote;
                            this.pageTitleService.pageTitle.next({
                                title: Constants.CmhConnectionTitle,
                                subTitle: Constants.CurrentQuoteSubTitle + (
                                    dbQuote.iseriesQuoteNumber > 0 && dbQuote.QuoteStatusesID > 0
                                        ? dbQuote.iseriesQuoteNumber
                                        : this.quoteId
                                )
                            });
                            this.quoteInfoService.quote$.next(dbQuote);

                            const canAccessQuoteSub = this.quoteInfoService.canAccessQuote$
                                .subscribe(
                                    (canAccessQuote => {
                                        if (canAccessQuote === true) {
                                            this.stateIsInvalid = false;
                                            this.InitializeLists().subscribe(
                                                data => { },
                                                error => {
                                                    this.spinner.hideSpinner();
                                                    this.httpResponseService.httpErrorResponse$.next(error);
                                                },
                                                () => this.spinner.hideSpinner());
                                        } else {
                                            this.spinner.hideSpinner();
                                        }
                                    }),
                                    (error => {
                                        this.spinner.hideSpinner();
                                        this.httpResponseService.httpErrorResponse$.next(error);
                                    }),
                                    (() => { this.spinner.hideSpinner(); })
                                );
                            this.subscription.add(canAccessQuoteSub);
                        } else {
                            this.stateIsInvalid = true;
                            this.modalDialogService.showMessage({
                                headerText: 'Choose Product Line',
                                message: Constants.QuoteNotFoundMessage.replace('#quoteid#', this.quoteId.toString())
                            }).subscribe(messageReply => {
                                this.redirectRequired();
                            });
                        }
                    }),
                    (error => {
                        this.spinner.hideSpinner();
                        this.httpResponseService.httpErrorResponse$.next(error);
                    }),
            );
        }
        else {
            this.processing.next(false);
        }

        const currentPricingViewSub = this.quoteInfoService.currentPricingView$.subscribe(x => {
            this.quoteSummaryService.calculatePrices();
        });
        this.subscription.add(currentPricingViewSub);

    }

    ngAfterViewInit() {
        this.applicationStateService.chosenProductLine = undefined;
        const searchTermChangeSub = this.searchTermChange.subscribe(x => {
            this.processing.next(true);
            this.searchPipeValue = x;
        });
        this.subscription.add(searchTermChangeSub);

        this.search = Observable.fromEvent(this.input.nativeElement, 'keyup').debounceTime(250);
        this.input.nativeElement.value = '';

        const searchSub = this.search.subscribe(
            x => {
                this.searchTerm = x.target.value;
            }
        );
        this.subscription.add(searchSub);
    }

    ngOnDestroy() {
        this.pageTitleService.pageName.next(null);
        this.subscription.unsubscribe();
    }

    showFilter() {
        this.filterProductLinesService.showFilter();
    }

    redirectRequired() {
        this.stateIsInvalid = true;
        this.router.navigate([Constants.NewQuotesUrl]);
    }

    InitializeLists() {
        return this.facilityService.getFacilitiesByRetailerNumber(this.currentRetailerNumber, this.currentUserId, this.showOnlyFavorites, true)
            .map(facilities => {
                this._facilityCache = facilities;
                this._facilityCache.forEach(fac => {
                    fac.Selected = true;
                    fac.Collapsed = false;
                    fac.ProductLinesCache = fac.ProductLines;
                });
                this.filterProductLinesService._facilityMasterList.next(this._facilityCache);
                this.filterProductLinesService._facilityCache.next(this._facilityCache);

                this.processing.next(false);
            });
    }

    toggleFacilityCollapse(fac: Facility) {
        fac.Collapsed = !fac.Collapsed;
    }

    checkProductLines(productLine: ProductLine) {
        this.applicationStateService.chosenProductLine = this.applicationStateService.chosenProductLine === undefined || this.applicationStateService.chosenProductLine === null ? undefined : this.applicationStateService.chosenProductLine;
        if (this.applicationStateService.chosenProductLine === undefined) {
            if (this.quote.productLineId !== productLine.ProductLineId && (this.quote.productLineId !== 0 && this.quote.productLineId !== undefined)) {
                this.applicationStateService.chosenProductLine = productLine;
                this.toast = {
                    type: 'warning',
                    title: 'Warning',
                    body: ToastrProductLinesComponent,
                    bodyOutputType: BodyOutputType.Component,
                    timeout: 0
                }
                this.selectAll = false;
                this.toasterService.pop(this.toast);
            } else {
                this.chooseModels(productLine);
            }
        }
    }

    chooseModels(productLine: ProductLine) {
        this.spinner.showSpinner();
        this.quote.modifiedBy = this.modifiedBy;
        this.applicationStateService.setQuote(this.quote);
        const setProductLineSub = this.applicationStateService.setProductLine(productLine)
            .map(response => {
                this.applicationStateService.setQuote(response);
            })
            .subscribe(
                (data => { }),
                (error => {
                    this.spinner.hideSpinner();
                    this.httpResponseService.httpErrorResponse$.next(error);
                }),
                () => {
                    this.toasterService.pop('success', 'Success!', 'Product Line has been saved');
                    if (productLine.Metadata !== undefined && productLine.Metadata !== null
                        && productLine.Metadata.ModelId !== 0 !== null && productLine.Metadata.ModelId !== 0) {
                        let m = new Model();
                        m.ModelId = productLine.Metadata.ModelId;
                        this.informationAsideModelsService.checkModels(m);
                    } else {
                        this.router.navigate(['choose-model', this.quote.quoteId]);
                    }
                });
        this.subscription.add(setProductLineSub);
    }

    favoriteItem(productLine: ProductLine, e: Event) {
        e.stopPropagation();
        let productLineFavorite = new ProductLineFavorites();
        productLineFavorite.UserId = this.currentUserId;
        productLineFavorite.ProductLineId = productLine.ProductLineId;

        this.userFavoritesService.createProductLineFavorite(productLineFavorite)
            .subscribe(
                (plf => {
                    productLine.Favorite = true;
                    this.facilityService.mergeFavoriteUnfavorite(productLine.ProductLineId, true);
                    this.favoriteUpdated.next(Math.random());
                }),
                (error => {
                    this.httpResponseService.httpErrorResponse$.next(error);
                })
            );

    }

    unfavoriteItem(productLine: ProductLine, e: Event) {
        e.stopPropagation();

        this.userFavoritesService.deleteProductLineFavorite(productLine.ProductLineId)
            .subscribe(
                (success => {
                    if (success) {
                        productLine.Favorite = false;
                        this.facilityService.mergeFavoriteUnfavorite(productLine.ProductLineId, false);
                        this.favoriteUpdated.next(Math.random());
                    }
                }),
                (error => {
                    this.httpResponseService.httpErrorResponse$.next(error);
                })
            );
    }

    filterChange(plantid: number) {
        const filterChangeSub = this.filterProductLinesService._facilityCache.asObservable()
            .subscribe(x => {
                let temp = new Set();
                x.forEach(pli => { if (pli.PlantId === plantid) { pli.Selected = true; } else { pli.Selected = false; } });
                x.forEach(a => { temp.add(a.Selected); });
                this.selectAll = temp.size === 2 || temp.has(false) ? false : true;
            });
        this.subscription.add(filterChangeSub);
        this.filterProductLinesService.checkForNoMatches();
    }

    updateAllChecked(event) {
        let temp = [];
        const updateAllCheckedSub = this.filterProductLinesService._facilityCache.asObservable()
            .flatMap(x => { return x })
            .do(x => {
                if (event === true) {
                    temp.push(event);
                }
            })
            .map(x => { return x.Selected = event; })
            .subscribe(x => {
                if (temp.length === 0) {
                    this.filterProductLinesService._noMatchesViewStatus = true;
                } else {
                    this.filterProductLinesService._noMatchesViewStatus = false;
                }
            });
        this.subscription.add(updateAllCheckedSub);
        this.filterProductLinesService.checkForNoMatches();
    }

    canDeactivate(): boolean {
        if (this.quote === undefined) { this.quote = this.applicationStateService.getQuote(); }

        if (this.quoteInfoService.canAccessQuote$.value === true && !this.stateIsInvalid) {
            let productLineId = this.applicationStateService.getQuote().productLineId;
            if ((productLineId !== undefined && productLineId !== null && productLineId !== 0)
                || (this.quote.productLineId !== undefined && this.quote.productLineId !== null && this.quote.productLineId !== 0)) {
                return true;
            }
            if (!this.showingDeactivateModal) {
                this.showingDeactivateModal = true;
                this.modalDialogService.showMessage({
                    headerText: 'Choose Product Line',
                    message: 'Please select a Product Line to continue.'
                }).subscribe(messageReply => {
                    this.showingDeactivateModal = false;
                });
            }
            return false;
        } else {
            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/product-lines/productlines.component.ts